'use strict';

import {changeLangToCurrent, getCurrentLang, isDesktopMode} from "../language/langSwitcher";

export class PrivacyAndTerms {
    static #allElements = [];
    static #privacy = null;
    static #terms = null;
    #element = document.createElement('div');
    #delimiter = null;

    static #getTerms() {
        const url = config.general.eula.find(el => el.lang === getCurrentLang()).value;
        if (!!(url)) return url;
        return `./assets/privacy/${getCurrentLang()}/terms.pdf`;
    }

    static #getPrivacy() {
        const url = config.general.privacyPolicy.find(el => el.lang === getCurrentLang()).value;
        if (!!(url)) return url;
        return `./assets/privacy/${getCurrentLang()}/privacy.pdf`;
    }

    static updateItems() {
        PrivacyAndTerms.#terms = PrivacyAndTerms.#getTerms();
        PrivacyAndTerms.#privacy = PrivacyAndTerms.#getPrivacy();

        PrivacyAndTerms.#allElements.forEach((element) => {
           element.querySelector('[data-dictionary="Privacy"]').href = PrivacyAndTerms.#privacy;
           element.querySelector('[data-dictionary="Terms"]').href = PrivacyAndTerms.#terms;
        });
    }

    constructor(args) {
        PrivacyAndTerms.#terms = PrivacyAndTerms.#getTerms();
        PrivacyAndTerms.#privacy = PrivacyAndTerms.#getPrivacy();

        if (!PrivacyAndTerms.#terms && !PrivacyAndTerms.#privacy || isDesktopMode()) return;

        PrivacyAndTerms.#allElements.push(this.#element);
        this.#element.classList.add('privacy-and-terms');

        args.parent.appendChild(this.#element);

        this.#addContent();
    }

    #addContent() {
        this.#addItem('Privacy');
        this.#addDelimiter();
        this.#addItem('Terms');

        if (PrivacyAndTerms.#terms && PrivacyAndTerms.#privacy)
            this.#delimiter.classList.remove('hidden');
    }

    #addItem(title) {
        if (title === 'Privacy' && !PrivacyAndTerms.#privacy ||
            title === 'Terms' && !PrivacyAndTerms.#terms) return;

        const item = document.createElement('a');
        item.classList.add(
            'privacy-and-terms__item',
            'aside__navigation-menu__href',
            'language-string'
        );
        item.setAttribute('target','_blank');
        item.setAttribute('data-dictionary', title);
        item.innerHTML = changeLangToCurrent(title);

        switch (title) {
            case 'Privacy':
                item.href = PrivacyAndTerms.#privacy;
                break;
            case 'Terms':
                item.href = PrivacyAndTerms.#terms;
                break;
            default:
                console.log('Privacy policy default case in addItem method. Something went wrong');
            break;
        }

        this.#element.appendChild(item);
    }

    #addDelimiter() {
        this.#delimiter = document.createElement('span');
        this.#delimiter.classList.add('privacy-and-terms__delimiter', 'hidden');
        this.#delimiter.innerHTML = '|';
        this.#element.appendChild(this.#delimiter);
    }

    show() {
        this.#element.classList.remove('hidden');
    }

    hide() {
        this.#element.classList.add('hidden');
    }
}
